'use strict';

namespace Attractions {

    class AttractionsBasketModal {

        lineItems: any[];
        total: number;

        constructor (
            private $location: ng.ILocationService,
            private $scope: ng.IScope,
            private modalService: any,
            private broker: any
        ) {
            broker.subscribe('AttractionsBasketModal', 'modal:ready', () => {
                this.total = modalService.get('total');
                this.lineItems = modalService.get('lineItems');
            });

            $scope.$on('$destroy', () => {
                broker.unsubscribe('AttractionsBasketModal');
            });
        }

        continueShopping (): void {
            this.modalService.close();
        }

        viewBasket (): void {
            this.$location.path('attractions/basket');
        }
    }

    angular
        .module('attractions')
        .controller('AttractionsBasketModal', AttractionsBasketModal);
}
